declare var swal: any;
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { HCPService } from '../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ActorImageRequest, ActorImageController } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { DBOperation } from '../../../../enums/enum';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';
import { ActorService } from '../../../../services/actor.service';
import { NgbdUploadActorImageModal } from '../modals/uploadactorimage/ngbuploadactorimage.modal';



@Component({
  selector: 'imageinfo',
  templateUrl: './imageinfo.component.html',
  styleUrls: ['./imageinfo.component.scss']
})

export class ActorImageInfoComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() CanShowRegistryView: number;

  public isRequesting: boolean = false;

  CurrentActorImageRequest: ActorImageRequest;
  CurrentActorImageController: ActorImageController;


  //
  public key: ActorImageController;

  @Input()
  get Key() {
    return this.key;
  }

  @Output() actorImageInfoChange = new EventEmitter();

  public ApiResData: ApiResponseModel;
  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService,
    private modalService: NgbModal) { }

  ngOnInit() {

    this.CurrentActorImageRequest = new ActorImageRequest();
    this.CurrentActorImageController = new ActorImageController();
    this.CurrentActorImageRequest.ActorCode = this.ActorCode;
    this.CurrentActorImageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.GetActorImageController();

  }

  GetActorImageController() {
    this.StartRefreshing();
    this.actorservice.GetActorImageController(this.CurrentActorImageRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentActorImageController = this.ApiResData.Result[0];
          this.key = this.ApiResData.Result[0];
          this.actorImageInfoChange.emit(this.key);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }


  openContent() {
    if (this.CurrentActorImageController.ActorImageCode != null && this.CurrentActorImageController.ActorImageCode > 0) {
      const modalRef = this.modalService.open(NgbdUploadActorImageModal,
        {
          centered:true
        })//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorImageCode = this.CurrentActorImageController.ActorImageCode;
      modalRef.componentInstance.ActorCode = this.CurrentActorImageController.ActorCode;
      modalRef.componentInstance.ActorImageFile == this.CurrentActorImageController.ActorImageFile;
      modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorImageController.ActorImageFileExtension;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;

      modalRef.result.then(x => { this.GetActorImageController() })
     
    }
    else {
      alertFunctions.AlertParam('access Denied..!');
    }
  }
  

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
